module.exports = __webpack_public_path__ + "static/media/landing-2.bbe46b24.png";